import React, { Component, Fragment } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationPaths } from './ApiAuthorizationConstants';
import AuthFunctions from '../services/AuthService';
import Session from '../auth/Session';
import authService from './AuthorizeService';

export class LoginMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: false,
            userName: null
        };
    }

    componentDidMount() {
        // this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
    }

    componentWillUnmount() {
        // authService.unsubscribe(this._subscription);
    }

    async populateState() {
        // const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        const isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        const userName = Session.getUserName();
        this.setState({
            isAuthenticated,
            userName: userName
        });
    }

    render() {
        const { isAuthenticated, userName } = this.state;
        if (!isAuthenticated) {
            const registerPath = `${ApplicationPaths.BaseIdentityRegisterPath}`;
            //const loginPath = `${ApplicationPaths.Login}`;
            const loginPath = `/login`;
            return this.anonymousView(registerPath, loginPath);
        } else {
            const profilePath = `${ApplicationPaths.Profile}`;
            //const logoutPath = { pathname: `${ApplicationPaths.LogOut}`, state: { local: true } };
            const logoutPath = { pathname: `/logout`, state: { local: true } };
            return this.authenticatedView(userName, profilePath, logoutPath);
        }
    }

    authenticatedView(userName, profilePath, logoutPath) {
        return (<Fragment>
            {/* <NavItem>
                <span className="text-dark nav-link">Hello {userName}</span>
            </NavItem> */}
            <NavItem>
                <NavLink tag={Link} className="text-dark" to={logoutPath}>Logout</NavLink>
            </NavItem>
        </Fragment>);

    }

    anonymousView(registerPath, loginPath) {
        return (<Fragment>
            {/* <NavItem>
                <NavLink tag={Link} className="text-dark" to={registerPath}>Register</NavLink>
            </NavItem> */}
            <NavItem>
                <NavLink tag={Link} className="text-dark" to={loginPath}>Login</NavLink>
            </NavItem>
        </Fragment>);
    }
}